import React, { useEffect, useState } from "react";
import PricingField from "./PricingField";
import { publicApi } from "../../lib/api";

// Grouped questions, one card per group — the section structure comes from the
// group each question already carries in the pricing platform.
export default function QuestionGroups({ groups, answers, onChange, missingKeys = [], testPrefix = "pricing" }) {
  // One help panel open at a time, closed by a click outside or Escape.
  const [openHelp, setOpenHelp] = useState(null);

  const toggleHelp = (key) => {
    setOpenHelp(key);
    if (key) publicApi.pricingHelpEvent(key);
  };

  useEffect(() => {
    if (!openHelp) return undefined;
    const outside = (e) => {
      const field = document.getElementById(`pj-field-${openHelp}`);
      if (field && !field.contains(e.target)) setOpenHelp(null);
    };
    const esc = (e) => {
      if (e.key === "Escape") {
        setOpenHelp(null);
        document.querySelector(`[data-testid="package-help-icon-${openHelp}"]`)?.focus();
      }
    };
    document.addEventListener("mousedown", outside);
    document.addEventListener("touchstart", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("touchstart", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [openHelp]);

  return (
    <div className="space-y-5" data-testid={`${testPrefix}-groups`}>
      {groups.map((g) => (
        <section
          key={g.name || "_"}
          data-testid={`${testPrefix}-group-${(g.name || "general").toLowerCase().replace(/\s+/g, "-")}`}
          className="rounded-2xl border border-slate-200 bg-white p-5 md:p-6"
        >
          {g.name && <h3 className="font-display font-bold text-navy text-base md:text-lg">{g.name}</h3>}
          <div className={`space-y-4 ${g.name ? "mt-4" : ""}`}>
            {g.questions.map((q) => (
              <PricingField
                key={q.key}
                question={q}
                value={answers[q.key]}
                onChange={onChange}
                highlight={missingKeys.includes(q.key)}
                openHelp={openHelp}
                onToggleHelp={toggleHelp}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
